import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ArrowDownSvg } from '../../assets/arrow-down-icon.svg';

export const ArrowDownIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ArrowDownSvg} {...props} />;
};
